import classNames from 'classnames';
import { Typography, TypographyTypes } from '../typography/typography';
import Icon from '../icons/icon';

interface BadgeProps {
  text: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  type?: 'default' | 'info' | 'success' | 'warning' | 'danger' | 'yellow' | 'black';
  showDot?: boolean;
  closeable?: boolean;
  dataCy?: string;
  onClose?: () => void;
}
export const Badge = ({
  text,
  className,
  size = 'medium',
  type = 'default',
  showDot = false,
  closeable = false,
  dataCy = '',
  onClose,
}: BadgeProps) => {
  const getBackgroundClass = () => {
    switch (type) {
      case 'default':
        return 'bg-grey-100';
      case 'info':
        return 'bg-blue-gray-50';
      case 'success':
        return 'bg-success-50';
      case 'warning':
        return 'bg-warning-50';
      case 'danger':
        return 'bg-error-50';
      case 'yellow':
        return 'bg-quipli-yellow-300';
      case 'black':
        return 'bg-grey-700';
    }
  };

  const getDotBackgroundClass = () => {
    switch (type) {
      case 'default':
        return 'bg-grey-500';
      case 'info':
        return 'bg-blue-gray-500';
      case 'success':
        return 'bg-success-500';
      case 'warning':
        return 'bg-warning-500';
      case 'danger':
        return 'bg-error-500';
      case 'yellow':
        return 'bg-quipli-black-500';
      case 'black':
        return 'bg-white';
    }
  };

  const getTextColorClass = () => {
    switch (type) {
      case 'default':
      case 'yellow':
        return '!text-grey-700';
      case 'info':
        return '!text-blue-gray-700';
      case 'success':
        return '!text-success-700';
      case 'warning':
        return '!text-warning-700';
      case 'danger':
        return '!text-error-700';
      case 'black':
        return '!text-white';
    }
  };

  const getTextSize = (): TypographyTypes => {
    switch (size) {
      case 'small':
        return TypographyTypes['text-xs'];
      case 'medium':
        return TypographyTypes['text-sm'];
      case 'large':
        return TypographyTypes['text-md'];
      default:
        return TypographyTypes['text-sm'];
    }
  };

  return (
    <div
      className={classNames(
        'rounded-2xl flex gap-[6px] items-center justify-center w-max',
        className,
        getBackgroundClass(),
        {
          'py-[2px] px-[8px]': size === 'small',
          'py-[2px] px-[10px]': size === 'medium',
          'py-[4px] px-[12px]': size === 'large',
        },
      )}
      data-cy={dataCy}
    >
      {showDot && <div className={classNames('w-[8px] h-[8px] rounded-full', getDotBackgroundClass())}></div>}
      <Typography type={getTextSize()} weight="medium" className={classNames(getTextColorClass())}>
        {text}
      </Typography>

      {closeable && (
        <div className="flex items-center cursor-pointer" onClick={onClose}>
          <Icon icon="Close" />
        </div>
      )}
    </div>
  );
};
